import { runDemo } from "../shared/demoRunner";
import { createLensScene } from "./scene";

runDemo({ createScene: createLensScene });
